export const colourScheme = {
    fullWhite: "#FFFFFF",
    white: "#F0F2F8",

    primaryDark: "#0D0F1D",
    primary: "#151729",
    primaryLight: "#2C2E52",

    secondaryLight: "#4CC2FF",
    secondary: "#0290E1",
    secondaryDark: "#0268A3",

    success: "#10E293",

    alert: "#FFBF00",
    errorDark: "#D42F2D",

    greyLight: "#B8B9C0",
    grey: "#7D7F89",

    darkGradientStart: "#192042",
    darkGradientEnd: "#0E0F19",

    shadow: "rgba(0, 0, 0, 0.6)",
};

export const hexToRgba = (hex: string, alpha: number): string => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const hexToRgb = (hex: string): string => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgb(${r}, ${g}, ${b})`;
};

export const darken = (color: string, amount: number) => {
    // Function to darken a hex color
    let usePound = false;

    if (color[0] === "#") {
        color = color.slice(1);
        usePound = true;
    }

    let num = parseInt(color, 16);

    let r = (num >> 16) - amount;
    if (r < 0) r = 0;
    if (r > 255) r = 255;

    let g = ((num >> 8) & 0x00ff) - amount;
    if (g < 0) g = 0;
    if (g > 255) g = 255;

    let b = (num & 0x0000ff) - amount;
    if (b < 0) b = 0;
    if (b > 255) b = 255;

    return (
        (usePound ? "#" : "") +
        ((r << 16) | (g << 8) | b).toString(16).padStart(6, "0")
    );
};

export const createVibrantGradient = (
    color1: string,
    color2: string,
    direction = "to right"
) => {
    return `linear-gradient(${direction}, ${color1}, ${color2})`;
};
